import { useQuery } from '@tanstack/react-query';
import type { ReviewResponse, ReviewStatus } from '../api/reviewApi';
import { ReviewApi } from '../api/reviewApi';

export function useProductReviews(productId: number, status?: ReviewStatus) {
  return useQuery<ReviewResponse[]>({
    queryKey: ['productReviews', productId, status],
    queryFn: () => ReviewApi.getReviews(productId, status),
    enabled: Boolean(productId),
  });
}
